import React, { useState } from 'react'
import { ReportCashOut } from './panels/ReportCashOut';
import { NewCashOut } from './panels/NewCashOut';

export const CashOut = () => {
   
    // ToDo:
    //  Este modulo cambia la interfaz de acuerdo al estado muestra reporte o captura. 

    const [view, setView] = useState('reporte'); // 'reporte' | 'nuevo'

    return (
        <div >
            <h3 className="h2 mb-3 fw-bold">{view === 'reporte' ? 'Corte de Caja' : 'Registro de Corte'}</h3>
            <div className="d-flex justify-content-between align-items-center ">
                {view === 'reporte' ? (
                    <button className="btn btn-outline-primary mb-3" onClick={() => setView('nuevo')}>
                        Nuevo Corte
                    </button>
                ) : null}
            </div>
            <div className='container-fluid'>
                {(view) === 'reporte' ? <ReportCashOut /> : <NewCashOut onCancel={() => setView('reporte')} />}
            </div>

            {/* <div className='row pdfViewer'>
                
            </div> */}
        </div>
    )
}
